import React, { useState } from "react";
import "../style.scss";
import Status from "./status";

const GymFilter = () => {

  const [selectedGymType, setSelectedGymType] = useState("Commercial"); 

  const getStatus = (status) => {
    // You can handle the status value here as needed
    console.log("Selected Status:", status);
  }

  return(
    <div className="w-full">
      <p className="fs-16 m-b-6 font-weight-700 color-black">Gym Type</p>
      <div className="d-flex-wrap space-between m-b-20 m-t-8">
        <div className="d-flex" onClick={() => setSelectedGymType("Commercial")}>
          <input className="flex-item m-r-8" type="radio" checked={selectedGymType === "Commercial"} style={{width:"16px", height:"16px"}} />
          <p className="flex-item fs-16 font-weight-600">Commercial</p>
        </div>
        <div className="d-flex" onClick={() => setSelectedGymType("Residential")}>
          <input className="flex-item m-r-8" type="radio" checked={selectedGymType === "Residential"}  style={{width:"16px", height:"16px"}}/>
          <p className="flex-item fs-16 font-weight-600">Residential</p>
        </div>
        <div className="d-flex" onClick={() => setSelectedGymType("Corporate")}>
          <input className="flex-item m-r-8" type="radio" checked={selectedGymType === "Corporate"}  style={{width:"16px", height:"16px"}}/>
          <p className="flex-item fs-16 font-weight-600">Corporate</p>
        </div>
      </div>
      <Status getStatus={getStatus} />
    </div>
  )
}

export default GymFilter;